import {Component, OnInit, Input}        from '@angular/core';
import {DomSanitizationService} from '@angular/platform-browser';
declare var $: any;
import {EmpresaService} from './empresa.service';
import {ProvinciaService} from '../provincia/provincia.service';
import {PermisoService} from '../permiso/permiso.service';
import {NotificacionService} from '../notificacion/notificacion.service';
import {LoginService} from '../login/login.service';
import {Empresa} from './empresa';
import {Contacto} from './contacto';
import {Provincia} from '../provincia/provincia';
import {RecargaCreditoService} from '../recargaCredito/recargaCredito.service';
import {ActivatedRoute, Router} from '@angular/router';

import {RecargaCreditoComponent} from '../recargaCredito/recargaCredito.component';
import {PlanService} from '../plan/plan.service';
import {Plan} from '../plan/plan';
import 'rxjs/Rx';

import myGlobals = require('../config');

@Component({
    selector: 'empresa',
    template: require('../../app/empresa/empresa.component.html'),
    styles: [require('../../app/empresa/empresa.component.css')],
    directives: [RecargaCreditoComponent],
})
export class EmpresaComponent implements OnInit {
    empresa: Empresa;
    contacto: Contacto;
    idSeleccionado;
    modificoContacto;
    active: any;
    active2: any;
    provincias: Provincia[];
    localidades: any;
    deshabilitar: boolean;
    permisos: any;
    permisosRecargas: any;
    urlLogo: any;
    filesToUpload: any;
    notificaciones: any;
    recargasCredito: any;
    mensajesRecargasMes: number;
    mensajesGastadosMes: number;
    usuario: any;
    planes: Plan[];

    constructor(private empresaService: EmpresaService,
                private provinciaService: ProvinciaService,
                private notificacionService: NotificacionService,
                private recargaCreditoService: RecargaCreditoService,
                private planService: PlanService,
                private route: ActivatedRoute,
                private loginService: LoginService,
                private permisoService: PermisoService,
                private sanitizer: DomSanitizationService,
                private router: Router) {
    }

    ngOnInit() {
        window.scrollTo(0, 0);

        //Pedir permisos
        this.urlLogo = "";
        this.permisos = new Map();
        this.permisoService.getPermiso("empresa").subscribe(permisos => {
            for (let permiso of permisos.tipoPermiso) {
                this.permisos.set(permiso.descripcion, true);
            }
            //Si no tiene permiso para ver redirijo
            if (!this.permisos.get("read"))
                this.router.navigate(['/home']);
        });

        this.permisosRecargas = new Map();

        //Cargar planes
        this.planService.getPlanes()
            .subscribe(planes => {
                this.planes = planes;
                
                //Inicializar tabla después de cargar planes
                $("#grid-data").bootgrid({
                    ajax: true,
                    url: myGlobals.default.BASE_URL + "/empresa/empresasTable",
                    selection: true,
                    multiSelect: false,
                    rowSelect: true,
                    formatters: {
                        "estado": function (column, row) {
                            return row.estado == true ? "Activo" : "<span class=\"label label-danger\">Inactivo</span>"
                        },
                        "plan": function (column, row) {
                            if (row.plan) {
                                const planEncontrado = this.planes.find(plan => plan._id === row.plan);
                                return planEncontrado ? planEncontrado.descripcion : "Plan no encontrado";
                            }
                            return "Sin plan asignado";
                        }.bind(this)
                    },
                    ajaxSettings: {
                        headers: {
                            "Authorization": this.loginService.getToken()
                        },
                        method: "GET"
                    }
                })
            });
        
        //Cerrar alert
        $("#alertSeleccion").hide();

        //Inicializar banderas para resetear forms
        this.active = true;
        this.active2 = true;
        //Incializar contacto
        this.contacto = new Contacto();
        //Inicializar empresa
        this.empresa = new Empresa();
        this.empresa.contacto = [];
        //Inicilizar bandera
        this.modificoContacto = false;
        //Inicializar bandera deshabilitar
        this.deshabilitar = true;
        //Cargar provincias
        this.provinciaService.getProvincias()
            .subscribe(provincias => {
                this.provincias = provincias;
            });
        
        this.mensajesRecargasMes = 0;
        this.mensajesGastadosMes = 0;

        this.getRecargasMensajes = this.getRecargasMensajes.bind(this);
        this.usuario = this.loginService.getDecodeToken();
    }

    ngOnDestroy() {
    }

    agregar() {

        //Inicializo variables
        this.empresa = new Empresa();
        this.contacto = new Contacto();
        this.mensajesGastadosMes = 0;
        this.notificaciones = null;
        this.mensajesRecargasMes = 0;
        this.recargasCredito = null;
        //Seteo bandera para deshabilitar
        this.deshabilitar = false;
        this.urlLogo = "";
        this.filesToUpload = "";
        this.modificoContacto = false;
        //Muestro modal
        $("#modalEmpresa").modal("show");
        //Cerrar alert
        $("#alertSeleccion").hide();
    }

    modificar() {
        //Limpio foto
        this.urlLogo = "";
        this.filesToUpload = "";
        this.modificoContacto = false;
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco empresa
                this.empresaService
                    .getEmpresa(this.idSeleccionado)
                    .subscribe(empresa => {
                        //Cargo datos de la empresa
                        this.empresa = empresa;
                        this.cambiarLocalidades(empresa.provincia);
                        //Cargo foto
                        var byteArray = new Uint8Array(empresa.logo.data.data);
                        var file = new Blob([byteArray], {type: empresa.logo.contentType});
                        var reader = new FileReader();
                        reader.onloadend = function () {
                            this.urlLogo = reader.result;
                        }.bind(this);
                        if (file) {
                            reader.readAsDataURL(file);
                        } else {
                            this.urlLogo = "";
                        }
                    });

                //Pedir notificaciones
                this.mensajesGastadosMes = 0;
                this.notificaciones = null;
                this.notificacionService.getResumenNotificaciones(this.idSeleccionado).subscribe(resumenNotificaciones => {
                    this.notificaciones = resumenNotificaciones;
                    this.notificaciones.some((notificacion) => {
                        if (notificacion._id.year == new Date().getFullYear() &&
                            notificacion._id.month == new Date().getMonth() + 1) {
                            this.mensajesGastadosMes += notificacion.total;
                            return true;
                        }
                    })
                });

                //Pedir recargas
                this.getRecargasMensajes();

                //Seteo bandera para deshabilitar
                this.deshabilitar = false;
                //Muestro modal
                $("#modalEmpresa").modal("show");
            }
        }
    }

    eliminar() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco empresa
                this.empresaService
                    .getEmpresa(this.idSeleccionado)
                    .subscribe(empresa => {
                        this.empresaService.delete(empresa).subscribe(() => $("#grid-data").bootgrid("reload"));
                    });
            }
        }
    }

    ver() {
        //Limpio foto
        this.urlLogo = "";
        this.filesToUpload = "";
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco empresa
                this.empresaService
                    .getEmpresa(this.idSeleccionado)
                    .subscribe(empresa => {
                        this.cambiarLocalidades(empresa.provincia);
                        this.empresa = empresa;
                        if(empresa.logo){
                            var byteArray = new Uint8Array(empresa.logo.data.data);
                            var file = new Blob([byteArray], {type: empresa.logo.contentType});
                            var reader = new FileReader();
                            reader.onloadend = function () {
                                this.urlLogo = reader.result;
                            }.bind(this);
                            if (file) {
                                reader.readAsDataURL(file);
                            } else {
                                this.urlLogo = "";
                            }
                        }
                    });
                //Pedir notificaciones
                this.mensajesGastadosMes = 0;
                this.notificaciones = null;
                this.notificacionService.getResumenNotificaciones(this.idSeleccionado).subscribe(resumenNotificaciones => {
                    this.notificaciones = resumenNotificaciones;
                    this.notificaciones.some((notificacion) => {
                        if (notificacion._id.year == new Date().getFullYear() &&
                            notificacion._id.month == new Date().getMonth() + 1) {
                            this.mensajesGastadosMes += notificacion.total;
                            return true;
                        }
                    })
                });

                //Pedir recargas
                this.getRecargasMensajes();
                //Seteo bandera para deshabilitar
                this.deshabilitar = true;
                //Muestro modal
                $("#modalEmpresa").modal("show");

            }
        }
    }

    save() {
        this.empresaService
            .save(this.empresa, this.filesToUpload)
            .subscribe((empresa) => {
                this.empresa = empresa;
                //Inicializo variables
                this.empresa = new Empresa();
                //this.empresa.logo=this.filesToUpload;
                this.contacto = new Contacto();
                //Ocultar modal
                $("#modalEmpresa").modal("hide");
                //Reseteo formEmpresa para eliminar errores
                this.active = false;
                setTimeout(() => this.active = true, 0);
                //Recargo tabla
                $("#grid-data").bootgrid("reload");
            })
    }

    public getRecargasMensajes() {
        this.mensajesRecargasMes = 0;
        this.recargasCredito = null;
        if (this.permisosRecargas.get("read"))
            this.recargaCreditoService.getRecargasCreditoByEmpresa(this.idSeleccionado).subscribe(recargas => {
                this.recargasCredito = recargas;
                this.recargasCredito.forEach((recarga) => {
                    if (new Date(recarga.fechaRecarga).getFullYear() == new Date().getFullYear() &&
                        new Date(recarga.fechaRecarga).getMonth() == new Date().getMonth() && recarga.estado) {
                        this.mensajesRecargasMes += recarga.valor;
                    }
                })
            });
    }

    agregarContacto() {
        if (!this.modificoContacto) {
            //Inicializar arreglo
            if (this.empresa.contacto == undefined)
                this.empresa.contacto = [];
            //Agregar contacto
            this.empresa.contacto.push(this.contacto);
            //Limpiar contacto
            this.contacto = new Contacto();
        }
        else {
            //Limpiar contacto
            this.contacto = new Contacto();
            //Seteo bandera
            this.modificoContacto = false;
        }
        //Reseteo formContacto para eliminar errores
        setTimeout(() => this.active2 = false, 0);
        setTimeout(() => this.active2 = true, 0);
    }

    modificarContacto(index) {
        //Traer contacto
        this.contacto = this.empresa.contacto[index];
        //Seteo bandera
        this.modificoContacto = true;
    }

    eliminarContacto(index) {
        //Eliminar contacto de la lista
        this.empresa.contacto.splice(index, 1);
    }

    hideAlert() {
        $("#alertSeleccion").hide();
    }

    cambiarLocalidades(nombre) {
        this.provinciaService.getProvincia(nombre)
            .subscribe(provincia => {
                this.localidades = provincia.localidades;
            });
    }

    verFoto(input) {
        if (input.files.length > 0) {
            var file = input.files[0];
            if (file.size > 1000000) {
                alert("La imagen no puede pesar mas de 1 mb.");
            }
            else {

                var reader = new FileReader();
                reader.onloadend = function () {
                    this.urlLogo = this.sanitizer.bypassSecurityTrustUrl(reader.result);
                }.bind(this);

                if (file) {
                    reader.readAsDataURL(file);
                } else {
                    this.urlLogo = "";
                }
                this.filesToUpload = file;
            }
        }
    }


    cerrarModal() {
        //Reseteo formEmpresa para eliminar errores
        this.active = false;
        setTimeout(() => this.active = true, 0);
        //Reseteo formContacto para eliminar errores
        setTimeout(() => this.active2 = false, 0);
        setTimeout(() => this.active2 = true, 0);
        this.empresa = new Empresa();
        $("#modalEmpresa").modal("hide");
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/empresa/empresa.component.ts